// @ts-nocheck


import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { RangePicker } from '../../../../../components/ui';

import {
  Filter,
  FilterButtonsContainer,
  FilterContainer,
  FilterItem,
  OrgUnitSelect,
  Selects } from
'./../../../../../components';
import Field from './../../../../../components/card/Field';

import { formatDateTimeToISOString } from './../../../../../lib/helpers';



const { EntityStatusSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "FilterWorkPlans__SpoilerContent", componentId: "sc-w977h5-0" })(["padding:16px;"]);


















export default ({ filter, cleanFilter, applyFilter }) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
              onlyBranches
              size="small"
              placeholder="Подразделение"
              onChange={(value) => changeValue('orgUnitId', value)}
              value={values.orgUnitId} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
              size="small"
              startDate={
              values.startDate ? moment.utc(values.startDate) : null
              }
              endDate={values.endDate ? moment.utc(values.endDate) : null}
              onChange={changeValue} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <EntityStatusSelect
              size="small"
              onChange={(value) => changeValue('status', value)}
              value={values.status} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
